// TODO: To ve removed after INTEGRATE-3825

export const FEATURED = { key: 'featured', name: 'Featured' };
export const MOST_POPULAR = { key: 'most-popular', name: 'Most Popular' };

export const ANALYTICS_REPORTING = { key: 'analytics-reporting', name: 'Analytics & Reporting' };
export const AUTOMATION = { key: 'automation', name: 'Automation' };
export const COLLABORATION = { key: 'collaboration', name: 'Collaboration' };
export const E_COMMERCE = { key: 'e-commerce', name: 'E-commerce' };
export const DIGITAL_EXPERIENCE = { key: 'digital-experience', name: 'Digital/Web Experience' };
export const MARKETING = { key: 'marketing', name: 'Marketing' };
export const CRM = { key: 'crm', name: 'CRM' };
export const CUSTOMER_SUPPORT = { key: 'customer-support', name: 'Customer Support' };
export const SOCIAL = { key: 'social', name: 'Social' };
export const HRIS = { key: 'hris', name: 'HRIS' };
export const PRODUCTIVITY = { key: 'productivity', name: 'Productivity' };
export const EDUCATION = { key: 'education', name: 'Education' };
export const REWARDS = { key: 'rewards', name: 'Rewards' };
export const EVENTS = { key: 'events', name: 'Events' };

export const BY_SURVEYMONKEY = { key: 'by-surveymonkey', name: 'Built by SurveyMonkey' };
export const BY_PARTNER = { key: 'by-partner', name: 'Built by Partner' };
export const ZAPIER_ENABLED = { key: 'zapier-enabled', name: 'Enabled via Zapier' };

export const SM_FREE_PLAN = { key: 'sm-free-plan', name: 'SurveyMonkey Free Plan' };
export const SM_PAID_PLAN = { key: 'sm-paid-plan', name: 'SurveyMonkey Paid Plan' };
export const SM_ENTERPRISE_PLAN = { key: 'sm-enterprise-plan', name: 'SurveyMonkey Enterprise Plan' };

export const DEFAULT_FILTERS = [FEATURED, MOST_POPULAR];

export const APP_CATEGORIES = [
  ANALYTICS_REPORTING,
  AUTOMATION,
  COLLABORATION,
  E_COMMERCE,
  DIGITAL_EXPERIENCE,
  MARKETING,
  CRM,
  CUSTOMER_SUPPORT,
  SOCIAL,
  HRIS,
  PRODUCTIVITY,
  EDUCATION,
  REWARDS,
  EVENTS,
];

export const INTEGRATE_TYPES = [BY_SURVEYMONKEY, BY_PARTNER, ZAPIER_ENABLED];

export const AVAILABLE_IN = [SM_FREE_PLAN, SM_PAID_PLAN, SM_ENTERPRISE_PLAN];

export const ALL_CATEGORIES = [...DEFAULT_FILTERS, ...APP_CATEGORIES, ...INTEGRATE_TYPES, ...AVAILABLE_IN];

export const getCategoryFromKey = key => {
  const results = ALL_CATEGORIES.filter(cat => cat.key === key);
  return results[0] || {};
};
